import { autoinject, bindable, bindingMode, TaskQueue } from 'aurelia-framework';
import { TaskActionService } from '../../TaskActionService';
import { UiActionButton } from '../../UiActionButton';
import { PageMessageService } from '../../../../services/page-message-service';
import { BusyService } from '../../../../services/busy-service';
import { DialogService } from 'aurelia-dialog';
import { WebApiService } from '../../../../services/web-api-service';
import { SecurityService } from '../../../../services/security-service';
import { CmpTaskDto } from '../../../../data/typegen/dtos/cmp-task-dto';
import { TaskState } from '../../../../data/enums/taskState';
import { validateTrigger, ValidationController, ValidationControllerFactory } from 'aurelia-validation';
import { DefaultValidationRenderer } from '../../../../resources/renderers/default-validation-renderer';
import { FulfillmentWidget, IFulfillmentWidget } from '../../new-user-request/new-user-request-fulfillment';
import { AppMessageService } from '../../../../services/app-message-service';
import { DoUiActionDto } from '../../../../data/typegen/dtos/do-ui-action-dto';
import { CmpTaskBaseDto } from '../../../../data/typegen/dtos/cmp-task-base-dto';
import { DoUiActionClientHandlerResult } from '../../../../data/dtos/do-ui-action-client-handler-result';
import { PromptDialog } from '../../../../resources/dialogs/prompt-dialog';
import { ComposeEmailDialog } from '../../../dialogs/compose-email-dialog/compose-email-dialog';
import { Globals } from '../../../../models/globals';
import { DisplayValuePair } from '../../../../data/typegen/dtos/display-value-pair';
import { TaskAssignmentGroups } from '../../../../data/typegen/enums/task-assignment-groups';
import { SimpleDialog } from '../../../dialogs/simple-dialog';
import { CurrencyValueConverter } from '../../../../resources/value-converters/currency';
import { RequestDetailsScreenDataDto } from '../../../../data/typegen/dtos/request-details-screen-data-dto';
import { RequestDto } from '../../../../data/typegen/dtos/request-dto';
import { TaskClass } from '../../../../data/typegen/enums/task-class';
import { DuplicateRequestDto } from '../../../../models/duplicate-request-dto';

@autoinject()
export class NewCarrierRequestFulfillment extends FulfillmentWidget implements IFulfillmentWidget {
    requestCorrection: UiActionButton;
    finalApprove: UiActionButton;
    finalDeny: UiActionButton;
    verifyInsuranceCoverageBtn: UiActionButton;
    setMasterApproved: UiActionButton;

    public entityTypes: { id: string; description: string; }[] = new Globals().getEntityTypes();
    //private assignableUsers: Array<DisplayValuePair<string>> = [];
    private assignableUsersCarrier: Array<DisplayValuePair<string>> = [];
    private assignableUsersTransloader: Array<DisplayValuePair<string>> = [];
    public primaryAgentOptGroups: Array<any> = [];

    public invalidFields: any = {
    };

    public fmcsaFieldValues: { [key: string]: any };
    public fmcsaDiscrepancies: {
        _hasValues: boolean
    };
    public duplicateRequests: DuplicateRequestDto[] = undefined
    private duplicateRequestsLoadedDotNumber: string = "";
    public forceFmcsaDetailRefresh: boolean = false;

    public get isTrucksCarrier(): boolean {
        return this.task && (this.task.variables.EntityType == "TRUCKS" || this.task.variables.EntityType == 'TRANSLOADER/TRUCKS');
    }

    async validate(controller: ValidationController, obj) {
        // Initialize the form validation status to true
        let isFormValid = true;

        // Proceed with validation only if the component is not in readonly mode
        if (!this.isComponentReadonly) {
            for (var field in this.task.variables) {
                // Ensure the property belongs to the task variables object itself
                if (this.task.variables.hasOwnProperty(field)) {
                    // If the current field is valid, update the field's error 
                    //  state and set form validation status accordingly
                    var isFieldValid = this.isFieldValid(field);
                    if (!isFieldValid) {
                        this.invalidFields[field] = "has-error";
                        isFormValid = false;
                    } else {
                        this.invalidFields[field] = "";
                    }
                }
            }
        }
        return isFormValid;

        // Note: The following line is commented out. It could be used to add a specific error to the controller.
        // controller.addError("that's a no no", this, "task.variables.DotNumber");
    }

    private isFieldValid(field: string) {
        switch (field) {
            case "ContactEmail":
                return this.isEmail(field);
            case "TypeOfAuthority":
                // Type of Authority required for trucks
                return !this.isTrucksCarrier || this.isNotEmpty(field);;
            case "TaxId":
                // tax id is optional for internal Requestors, although required for carrier registration
                return true;
            case "LegalName":
            case "RequiredInsurance":
            case "Divisions":
                return this.isNotEmpty(field);
            case "DotNumber":
                if (this.isTrucksCarrier) {
                    return this.isNotEmpty(field);
                }
                return true;
            default:
                return true;
        }
    }

    private isEmail(field: string) {
        const vars = this.task.variables;
        const val = vars[field];
        return val && val.toString().match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,10}$/);
    }

    private isNotEmpty(field) {
        const vars = this.task.variables;
        return !!(vars[field]);
    }

    public isComponentReadonly = false;

    @bindable({ defaultBindingMode: bindingMode.oneWay }) audience: "requestor" | "fulfiller" | "any" = "any"; // indicates the type of audience this is targeted to
    @bindable({ defaultBindingMode: bindingMode.oneWay }) readonly: boolean;

    @bindable({ defaultBindingMode: bindingMode.oneWay }) task: CmpTaskBaseDto;
    taskChanged() {
        this.initUi();
    }

    public myDivisions = [];

    private async loadDuplicateRequests() {
        if (this.duplicateRequestsLoadedDotNumber == this.task.variables.DotNumber) {
            // for performance, don't load the same DOT # twice
            // user can refresh the page, if manual refresh is needed
            return;
        }


        this.busyService.on();
        try {
            const result = await this.api.get("Carriers", "GetCarrierRequestsByDotNumber", { dotNumber: this.task.variables.DotNumber })
            if (result.response) {
                this.duplicateRequests = JSON.parse(result.response);
            } else {
                this.duplicateRequests = [];
            }
            this.duplicateRequestsLoadedDotNumber = this.task.variables.DotNumber;
        } finally {
            this.busyService.off();
        }
    }

    public hasUnresolvedFmcsaDiscrepancies = false;
    public evaluateUnresolvedFmcsaDiscrepancies() {
        // check if any discrepancies are unresolved
        if (!this.fmcsaDiscrepancies || !this.task.variables.fmcsa_overrides) {
            this.hasUnresolvedFmcsaDiscrepancies = false;
        }
        const result = Object.keys(this.fmcsaDiscrepancies).some(key => key !== '_hasValues' && !this.hasFmcsaOverrides(key));
        this.hasUnresolvedFmcsaDiscrepancies = result;

        console.log("hasUnresolvedFmcsaDiscrepancies", this.hasUnresolvedFmcsaDiscrepancies);
    }

    public hasFmcsaOverrides(fieldName) {
        const result = this.task.variables.fmcsa_overrides && this.task.variables.fmcsa_overrides[fieldName];
        return result;
    }

    public clearFmcsaOverride(fieldName) {
        setTimeout(() => {
            this.forceFmcsaDetailRefresh = true;
            delete this.task.variables.fmcsa_overrides[fieldName];
            delete this.task.variables.fmcsa_override_notes[fieldName];
            console.log("overrides", this.task.variables.fmcsa_overrides);
            // add alert to page to remind user to save the task
            this.appMsg.addWarningMessage("FMCSA Discrepancy override - Please save the changes");
            this.evaluateUnresolvedFmcsaDiscrepancies();
            setTimeout(() => this.forceFmcsaDetailRefresh = false, 100);
        }, 100);
    }

    public async approveFmcsaDiscrepancy(fieldName) {
        setTimeout(() => {
            this.forceFmcsaDetailRefresh = true;
            // add override for the FMCSA discrepancy and add comment
            if (!this.task.additionalWorkNotes) {
                this.task.additionalWorkNotes = "";
            }
            // save the note and override status in the task variables
            const overrideNote = "FMCSA Discrepancy (value: " + this.fmcsaFieldValues[fieldName] + ") for " + fieldName + " overridden by " + this.securityService.user.fullName + " on " + new Date().toLocaleDateString() + ".";
            this.task.additionalWorkNotes += overrideNote + ".\n";
            this.task.variables.fmcsa_overrides[fieldName] = true;
            this.task.variables.fmcsa_override_notes[fieldName] = overrideNote;

            this.evaluateUnresolvedFmcsaDiscrepancies();


            // add alert to page to remind user to save this record
            this.appMsg.addWarningMessage("FMCSA Discrepancy override - Please save the changes");
            setTimeout(() => this.forceFmcsaDetailRefresh = false, 100);
        }, 100);
    }


    private loadFmcsaFieldDiscrepancies(isPreOnboarding: boolean) {

        // initialize the fmcsa_overrides object if it doesn't exist
        this.task.variables.fmcsa_overrides = this.task.variables.fmcsa_overrides || {};
        this.task.variables.fmcsa_override_notes = this.task.variables.fmcsa_override_notes || {};

        // Note: Don't load discrepancies here on the request/task once carrier has completed registration
        // (it is still enforced on the carrier profile screen)
        if (!isPreOnboarding) {
            this.fmcsaFieldValues = {};
            return;
        }
        

        this.busyService.on();

        // Make an API call to retrieve FMCSA data using the provided DOT number
        return this.api.get("Fmcsa", "GetSearchCarrier", { dotNumber: this.task.variables.DotNumber })
            .then((result) => {
                // Parse the response from the API to get FMCSA field values
                if (result.response) {
                    this.fmcsaFieldValues = JSON.parse(result.response);
                } else {
                    this.fmcsaFieldValues = {};
                }

                // Initialize an empty object to store discrepancies between FMCSA data and task variables
                this.fmcsaDiscrepancies = {
                    _hasValues: false
                };

                // Iterate over all properties of the FMCSA field values object
                for (const key in this.fmcsaFieldValues) {
                    // Convert the key to lowercase for comparison
                    const lowerCaseKey = key.toLowerCase();

                    // Ensure that the property exists in both FMCSA field values and task variables
                    // Note: Properties are not same case, so use a case-insensitive comparison approach.
                    if (this.fmcsaFieldValues.hasOwnProperty(key)) {
                        for (const taskKey in this.task.variables) {
                            if (lowerCaseKey == taskKey.toLowerCase()) {
                                // Retrieve the value from both FMCSA field values and task variables
                                const fmcsaValue = this.fmcsaFieldValues[key];
                                const taskValue = this.task.variables[taskKey];

                                // If the values are different, store the FMCSA value in the discrepancies object
                                if (fmcsaValue != taskValue) {
                                    this.fmcsaDiscrepancies[key] = { value: fmcsaValue };
                                    this.fmcsaDiscrepancies._hasValues = true;
                                }
                                break;
                            }
                        }
                    }
                }

                this.evaluateUnresolvedFmcsaDiscrepancies();
                this.busyService.off();
            });

    }


    private loadCarrierDivisions() {
        this.busyService.on();
        return this.api.get("Divisions", "GetDivisions")
            .then((result) => {
                this.myDivisions = JSON.parse(result.response);
                this.busyService.off();
            });
    }

    /**
     * Loads users that can be assigned to carrier and transloader tasks
     * by fetching members from their respective groups
     */
    async loadAssignableUsers() {
        // Show loading indicator while fetching data
        this.busyService.on();

        try {
            // Fetch both carrier and transloader group members in parallel
            await Promise.all([
                // Get users from carrier services group
                this.api.get("Tasks", "GetGroupMembers", { groupId: TaskAssignmentGroups.carrierServices })
                    .then((result) => {
                        console.log("Done1a");
                        this.assignableUsersCarrier = JSON.parse(result.response);
                    }),
                // Get users from transloader services group    
                this.api.get("Tasks", "GetGroupMembers", { groupId: TaskAssignmentGroups.transloaderServices })
                    .then((result) => {
                        console.log("Done1b");
                        this.assignableUsersTransloader = JSON.parse(result.response);
                    })
            ]);

            // Create option groups for the primary agent selection dropdown
            // Combining both carrier and transloader users into a structured format
            this.primaryAgentOptGroups = [
                {
                    label: "Carrier Services",
                    opts: this.assignableUsersCarrier
                },
                {
                    label: "Transloader Services",
                    opts: this.assignableUsersTransloader
                }
            ];
        } finally {
            // Hide loading indicator after data is loaded or if an error occurs
            this.busyService.off();
        }
    }
    controller: ValidationController = null;

    private sendRegistrationLink: UiActionButton
    private sendCarrierRegistrationFollowUp: UiActionButton;
    constructor(
        private controllerFactory: ValidationControllerFactory,
        private taskActionService: TaskActionService,
        private busyService: BusyService,
        private securityService: SecurityService,
        private appMsg: AppMessageService,
        private msg: PageMessageService,
        private dialogService: DialogService,
        private api: WebApiService,
        private currentConverter: CurrencyValueConverter,
        element: Element,
        private taskQueue: TaskQueue
    ) {
        super(element);

        this.controller = controllerFactory.createForCurrentScope();
        this.controller.validateTrigger = validateTrigger.change;
        this.controller.addRenderer(new DefaultValidationRenderer());

        // add UI actions based on the task key
        this.sendRegistrationLink = this.taskActionService.addUiAction({
            key: "send_registration_link",
            name: "Send Registration Invite"
        });
        this.sendCarrierRegistrationFollowUp = this.taskActionService.addUiAction({
            key: "send_carrier_follow_up",
            name: "Send Carrier Follow-Up"
        });


    }

    showCloseAction: boolean = false;

    public async showEmailDialog(email: string) {
        var result = await this.dialogService.open(
            {
                viewModel: ComposeEmailDialog,
                model: {
                    recipients: email,
                    targetRowId: this.task.taskId,
                    targetTable: this.task.taskClass.toString().toLowerCase()
                }
            });

    }

    public async initUi() {

        if (!this.isReady) return;

        let request: RequestDto;

        // if not a request, then get the request
        if (this.task.taskClass == TaskClass.Request) {
            request = this.task as RequestDto;
        } else if (this.task.taskClass == TaskClass.Task) {
            const result = await this.api.get("Tasks", "GetRequestDetailsScreenDataDto", { requestId: this.task.parent.value })
            const screenData = JSON.parse(result.response) as RequestDetailsScreenDataDto;
            request = screenData.request;
        }


        const workflowStage = request.workflowContext && request.workflowContext.stage;
        const isPreOnboarding = workflowStage == "PreApproval" || workflowStage == "CarrierRegistration";

        // load FMCSA values and mark any discrepancies
        this.loadFmcsaFieldDiscrepancies(isPreOnboarding);

        // look for duplicate requests for same DOT #
        this.loadDuplicateRequests();

        // hide all UI actions by default
        for (const prop in this) {
            if (this[prop] instanceof UiActionButton) {
                (<unknown>this[prop] as UiActionButton).visible = false;
            }
        }

        var carrierId = this.task.variables.CarrierId;
        var result = carrierId && await this.api.get("Carriers", "GetCarrierById", { carrierId: carrierId });
        const carrier = result && JSON.parse(result.response);


        if (this.task.variables.HasTrucks && !(carrier.entityType == "TRUCKS" || carrier.entityType == "TRANSLOADER/TRUCKS")) {
            this.msg.setInfoMessage("This carrier specified they have trucks, but the entity type on the Carrier record is set to " + carrier.entityType);
        }


        var isEditor = this.securityService.hasRole("Edit");
        this.isComponentReadonly = this.readonly || !this.task.active || !isEditor; // per Alisa, need to be able to edit fields for these request types. || this.task.variables.IsReevaluationRequest || this.task.variables.IsDormancyReviewRequest;


        // TODO: this needs further refinement before any work is done.
        // // make readonly if task is past the registration stage       
        // if (!this.isComponentReadonly && !isPreOnboarding) {
        //     this.isComponentReadonly = true;
        // }

        //only show UI actions when task is assigned and active
        const assignedToMe = this.task.assignedTo.value == this.securityService.user.id;
        const inProgressOrComplete = this.task.state.value == TaskState.InProgress || this.task.state.value == TaskState.ClosedComplete;
        const inProgress = this.task.state.value == TaskState.InProgress;
        const activeAssignedToMeInProgress = assignedToMe && inProgress

        this.showCloseAction = true;

        if (this.task.taskKey == "send_registration_link") {
            this.showCloseAction = false;
            this.sendRegistrationLink.visible = isPreOnboarding && inProgressOrComplete && request.active; // show the send button if the task is either started, and after it is complete, as long as the request is active.
            if (this.task.state.value == TaskState.ClosedComplete) {
                this.sendRegistrationLink.name = "Resend Registration Invite";
            }
        }

        if (this.task.taskKey == "send_carrier_follow_up") {
            this.sendRegistrationLink.name = "Resend Registration Invite";
            this.sendRegistrationLink.visible = isPreOnboarding && inProgressOrComplete && request.active; // show the resend button if the task is either started, and after it is complete, as long as the request is active.
        }

        if (this.task.taskKey == "review_approve_documents") {
            this.showCloseAction = false;
            this.requestCorrection = this.taskActionService.addUiAction({
                key: "final_request_correction",
                name: "Request Correction",
                visible: activeAssignedToMeInProgress
            });
            this.finalApprove = this.taskActionService.addUiAction({
                key: "final_approve",
                name: "Approve",
                visible: activeAssignedToMeInProgress
            });
            this.finalDeny = this.taskActionService.addUiAction({
                key: "final_deny",
                name: "Deny Carrier",
                visible: activeAssignedToMeInProgress
            });
        }

        if (this.task.taskKey == "initial_insurance_review") {
            this.showCloseAction = true;
            if (this.task.variables.RequiredInsurance > 100000) {
                if (!this.task.variables.verify_insurance_coverage) {
                    this.showCloseAction = false;
                    this.verifyInsuranceCoverageBtn = this.taskActionService.addUiAction({
                        key: "verify_insurance_coverage",
                        name: "Verify Insurance Coverage",
                        visible: activeAssignedToMeInProgress,
                        redirectAfterSubmit: false
                    });
                }
            }
        }

        if (this.task.taskKey == "master_approve") {
            this.showCloseAction = true; // show button
            if (!carrier) {
                this.msg.setErrorMessage("Carrier Not Found");
            }
            const isMasterApproved = carrier && carrier.status == 8;
            this.setMasterApproved = this.taskActionService.addUiAction({
                key: "set_master_approved",
                name: "Master Approve",
                redirectAfterSubmit: false,
                visible: activeAssignedToMeInProgress && !isMasterApproved
            });
        }
    }

    public async doAction(action: DoUiActionDto<CmpTaskBaseDto>): Promise<DoUiActionClientHandlerResult> {
        // don't allow closure of tasks until FMCSA discrepancies are corrected.
        if (action.taskDto.state.value == TaskState.ClosedComplete
            || action.uiActionVerb == this.sendRegistrationLink.key
        ) {

            if (this.fmcsaFieldValues.usDotStatus == 'I') {
                this.appMsg.addErrorMessage("Cannot send registration link while FMCSA Status is INACTIVE.  If the DOT # is incorrect, update it and save the record before completing the task.");
                return DoUiActionClientHandlerResult.stop;
            }
            else if (this.hasUnresolvedFmcsaDiscrepancies) {
                this.appMsg.addErrorMessage("Please correct the FMCSA discrepancies below and try again.");
                return DoUiActionClientHandlerResult.stop;
            }
        }



        if (this.verifyInsuranceCoverageBtn && action.uiActionVerb == this.verifyInsuranceCoverageBtn.key) {
            const cargoAmount = this.currentConverter.toView(this.task.variables.RequiredInsurance);
            const yesText = "Yes, I Confirm";
            const handlerResult = await this.dialogService.open({
                viewModel: SimpleDialog,
                model: {
                    title: "Verify Increased Insurance Coverage",
                    icon: "fa-exclamation-triangle",
                    message: `This request requires increased insurance coverage.\n\nDo you confirm this carrier has Cargo Insurance coverage of ${cargoAmount} or greater?`,
                    buttons: [yesText, "Cancel"]
                }
            }).whenClosed((result) => {
                if (result.output != yesText) {
                    return DoUiActionClientHandlerResult.stop;
                } else {
                    return DoUiActionClientHandlerResult.default;
                }
            });
            return handlerResult;
        }
        else if (this.requestCorrection && action.uiActionVerb == this.requestCorrection.key) {
            const question = "Describe the corrections or additional information that is needed";
            await this.dialogService.open(
                {
                    viewModel: PromptDialog,
                    model: question
                })
                .whenClosed((result) => {
                    if (result.output) {
                        action.payload = result.output;
                    }
                });
        }

        return DoUiActionClientHandlerResult.default;
        ;
    }

    public async afterActionSubmit(uiAction: string, error?: any): Promise<boolean> {
        if (uiAction == this.sendRegistrationLink.key && !error) {
            this.appMsg.addSuccessMessage("Registration link has been sent.");
        }
        // return true to reload the data
        return true;
    }

    private isReady = false;
    async attached() {
        // Initialize security service to ensure user permissions are loaded
        await this.securityService.init();

        // Load carrier divisions and assignable users in parallel for better performance
        await Promise.all([
            this.loadCarrierDivisions(),
            this.loadAssignableUsers()
        ]);

        // Mark component as ready for UI initialization
        this.isReady = true;

        // Initialize UI components and fire ready event
        await this.initUi();
        await this.fireOnreadyEvent();
    }
}